export const formatPrice = (value?: number | string) => {
  if (!value) {
    return "0";
  } else if (typeof value === "string") {
    return value.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  return value.toLocaleString();
};
